var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h6',{staticClass:"text-center text-error font-medium"},[_vm._v(_vm._s(_vm.comment)+".")])}
var staticRenderFns = []

export { render, staticRenderFns }